module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"list section-margin-bottom\"> ")
    ;  if (locals.firstFetchSuccess && locals.collection.length === 0) { 
    ; __append(" <p class=\"bold no_results\">")
    ; __append(escapeFn( locals.noResultsMessage ))
    ; __append("</p> ")
    ;  } else if (locals.collection.length > 0) { 
    ; __append(" <div class=\"row list__header\"> ")
    ;  _.each(locals.headings, function(h) { 
    ; __append(" <div class=\"")
    ; __append(escapeFn( h.computeClass() ))
    ; __append("\">")
    ; __append(escapeFn( h.display ))
    ; __append("</div> ")
    ;  }); 
    ; __append(" </div> <ul class=\"list__body\"> ")
    ;  _.each(locals.collection.models, function(model) { 
    ; __append(" <li id=\"")
    ; __append(escapeFn( locals.computeId(model.id || model.cid) ))
    ; __append("\" class=\"list__body__item row\"></li> ")
    ;  }); 
    ; __append(" </ul> ")
    ;  if (locals.hasNextPage) { 
    ; __append(" <button id=\"get_next_page\" class=\"btn btn-blue btn-block\">Show More</button> ")
    ;  } 
    ; __append(" ")
    ;  }
    ; __append(" ")
    ;  if (locals.fetchError) { 
    ; __append(" <div class=\"alert alert-danger\"> An error occurred while contacting the EasyPost service. If this problem persists, please contact <a href=\"mailto:support@easypost.com\">support@easypost.com</a>. </div> ")
    ;  } 
    ; __append(" </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/list/list/template.ejs
// module id = 792
// module chunks = 1